import OrderOverview from './overview'
module.exports = {
  OrderOverview
}



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/middlewares/orders/index.js